// Staff copy for the Settings sections of conversion group A (docs/design/settings-redesign.md):
// customer details, outcomes, marks, licence, organisations, installation settings,
// sign-in directory, approvals, queue alerts. English only; az and ru fall back to English.
import type { Phrase } from '../staffText'

const en = (text: string): Phrase => ({ en: text, az: '', ru: '' })

export const settingsOrg = {
  // Shared by the record lists (Fields, Outcomes, Marks).
  'settings.rec.inUse': en('In use'),
  'settings.rec.retired': en('Retired'),
  'settings.rec.off': en('Off'),

  // Customer details (admin/Fields.tsx).
  'settings.fields.line': en('What a ticket may carry besides its number.'),
  'settings.fields.list': en('Details'),

  // Outcomes and marks (admin/Outcomes.tsx, Marks.tsx).
  'settings.outcomes.line': en('What was done for the customer.'),
  'settings.marks.retiredList': en('Retired marks'),

  // Licence (admin/Licence.tsx).
  'settings.licence.line': en('What was bought and what is used.'),
  'settings.licence.status': en('Status'),
  'settings.licence.holder': en('Licensed to'),
  'settings.licence.code': en('Installation code'),
  'settings.licence.codeLine': en('Send it with a licence request.'),
  'settings.licence.copy': en('Copy'),
  'settings.licence.copied': en('Copied'),
  'settings.licence.apply': en('Apply licence'),
  'settings.licence.replace': en('Replace licence'),
  'settings.licence.checking': en('Checking…'),
  'settings.licence.file': en('Licence file'),
  'settings.licence.unlimitedWord': en('Unlimited'),
  'settings.licence.installation': en('Whole installation'),
  'settings.licence.organisation': en('This organisation'),
  'settings.licence.soft': en('Never blocked'),
  'settings.licence.issued': en('Issued'),
  'settings.licence.planLine': en('Your plan and its use.'),
  'settings.licence.request': en('Download request'),
  'settings.licence.revocations': en('Upload revocations'),
  'settings.licence.revocationList': en('Revocation list'),
  'settings.licence.revocationsApplied': en('Revocation list applied'),
  'settings.licence.applied': en('Licence applied'),
  'settings.licence.machine': en('Machine'),
  'settings.licence.host.primary': en('Primary'),
  'settings.licence.host.standby': en('Standby'),
  'settings.licence.trialEnds': en('Ends'),
  'settings.licence.seenAt': en('Clock last read'),

  // Organisations (admin/Organisations.tsx).
  'settings.orgs.line': en('Every organisation on this server.'),
  'settings.orgs.find': en('Search organisations'),
  'settings.orgs.col.org': en('Organisation'),
  'settings.orgs.col.zone': en('Time zone'),
  'settings.orgs.col.signin': en('Sign-in'),
  'settings.orgs.on': en('On'),
  'settings.orgs.off': en('Off'),
  'settings.orgs.yours': en('Yours'),
  'settings.orgs.open': en('Open'),

  // Installation settings (admin/Settings.tsx).
  'settings.install.line': en('Unset values follow'),

  // Sign-in directory (admin/Directory.tsx).
  'settings.directory.line': en('Staff sign in with their directory account.'),
  'settings.directory.address': en('Server'),
  'settings.directory.search': en('Search'),
  'settings.directory.signIn': en('Sign-in'),
  'settings.directory.order': en('Tried top to bottom; the first match gives the role.'),

  // Approvals (admin/BranchSettings.tsx, on the branch page).
  'settings.approvals.line': en('What waits for a manager, and who hears.'),
  'settings.approvals.requests': en('Requests'),
  'settings.approvals.request': en('Request'),
  'settings.approvals.address': en('Address'),
  'settings.approvals.noEmails': en('No addresses'),
  'settings.approvals.max': en('Five at most'),

  // Queue alerts (admin/QueueAlerts.tsx).
  'settings.alerts.line': en('When a queue warns, and who is texted.'),
  'settings.alerts.list': en('Queues'),
  'settings.alerts.find': en('Search queues'),
  'settings.alerts.all': en('All'),
  'settings.alerts.set': en('With an alert'),
  'settings.alerts.raised': en('Raised now'),

  // Languages (admin/Languages.tsx).
  'settings.languages': en('Languages'),
  'settings.languages.line': en('What staff and customers read.'),
  'settings.languages.also': en('language translation locale kiosk'),
  'settings.languages.staff': en('Staff'),
  'settings.languages.staffLang': en('Staff language'),
  'settings.languages.customers': en('Customers'),
  'settings.languages.customersLine': en('The first is the default.'),
  'settings.languages.default': en('Default'),
  'settings.languages.add': en('Add'),
  'settings.languages.addPick': en('Add language'),
  'settings.languages.up': en('Move {name} up'),
  'settings.languages.down': en('Move {name} down'),
  'settings.languages.remove': en('Remove {name}'),
  'settings.languages.saved': en('Languages saved'),
  'settings.languages.notLoaded': en('Languages could not be read.'),
} satisfies Record<`settings.${string}`, Phrase>
